import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu } from '@headlessui/react';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';
import styles from './Navbar.module.css';

const navigation = [
  { name: 'Home', href: '/' },
  { name: 'Pricing', href: '/pricing' },
  { name: 'Marketplace', href: '/marketplace' },
  { name: 'Sell', href: '/sell' },
  { name: 'History', href: '/history' },
  { name: 'Faucet', href: '/faucet' },
];

export default function Navbar({ account, openWalletModal, disconnectWallet }) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const truncatedAddress = account
    ? `${account.substring(0, 6)}...${account.substring(account.length - 4)}`
    : '';

  return (
    <nav className={styles.navbar}>
      <div className={styles.navbarContainer}>
        <div className={styles.logoContainer}>
          <Link to="/" className={styles.logo}>CodeXchange</Link>
        </div>
        <div className={styles.menuContainer}>
          {navigation.map((item) => (
            <Link key={item.name} to={item.href} className={styles.navLink}>
              {item.name}
            </Link>
          ))}
        </div>
        <div className={styles.walletContainer}>
          {account ? (
            <Menu as="div" className={styles.menuWrapper}>
              <Menu.Button className={styles.accountButton}>
                {truncatedAddress}
              </Menu.Button>
              <Menu.Items className={styles.menuItems}>
                <Menu.Item>
                  {({ active }) => (
                    <button
                      onClick={disconnectWallet}
                      className={`${styles.menuItem} ${active ? styles.menuItemActive : ''}`}
                    >
                      Disconnect
                    </button>
                  )}
                </Menu.Item>
              </Menu.Items>
            </Menu>
          ) : (
            <button
              onClick={openWalletModal}
              className={styles.connectButton}
            >
              Connect Wallet
            </button>
          )}
        </div>
        <div className={styles.mobileMenuButton}>
          <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
            {isMobileMenuOpen ? (
              <XMarkIcon className={styles.menuIcon} />
            ) : (
              <Bars3Icon className={styles.menuIcon} />
            )}
          </button>
        </div>
      </div>
      {isMobileMenuOpen && (
        <div className={styles.mobileMenu}>
          {navigation.map((item) => (
            <Link
              key={item.name}
              to={item.href}
              className={styles.mobileNavLink}
              onClick={() => setIsMobileMenuOpen(false)}
            >
              {item.name}
            </Link>
          ))}
        </div>
      )}
    </nav>
  );
}